var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path15, _path16, _path17, _path18, _polygon7, _polygon8, _polygon9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 104.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d75bd;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-2{fill:#00a79d;}.cls-3{fill:#ef4136;}.cls-4{fill:#fff;}.cls-5{fill:#4d4d4d;}.cls-6{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "binder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,1.91H36.48V102.55H4a4,4,0,0,1-2.83-1.17A4,4,0,0,1,0,98.56V5.91a4,4,0,0,1,4-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,4H34.37v96.43H4a1.89,1.89,0,0,1-1.89-1.89V5.91A1.89,1.89,0,0,1,4,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4,1.91H67.13a4,4,0,0,1,4,4V98.56a4,4,0,0,1-4,4H34.29V1.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.4,4H67.13A1.9,1.9,0,0,1,69,5.91V98.56a1.91,1.91,0,0,1-1.89,1.89H36.4V4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.51,5.35,101.85.06a4,4,0,0,1,4.61,3.21l16.36,91.22a4,4,0,0,1-3.22,4.63c-9.42,1.75-18.9,3.63-28.34,5.29a4,4,0,0,1-4.6-3.19C86.57,101.11,71.73,18,70.3,10A3.91,3.91,0,0,1,71,7a4,4,0,0,1,2.56-1.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.89,7.42l28.32-5.28a1.89,1.89,0,0,1,2.19,1.52l16.35,91.2a1.91,1.91,0,0,1-1.52,2.19l-28.32,5.28a1.89,1.89,0,0,1-2.19-1.53L72.36,9.61a1.9,1.9,0,0,1,1.53-2.19Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.84,10.75h14.8A3.3,3.3,0,0,1,28,11.7l.16.19A3.24,3.24,0,0,1,28.9,14V57.59a3.26,3.26,0,0,1-1,2.3,3.22,3.22,0,0,1-2.3,1H10.84a3.28,3.28,0,0,1-3.27-3.26V14a3.26,3.26,0,0,1,3.27-3.26Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.84,12.85h14.8A1.17,1.17,0,0,1,26.8,14V57.59a1.17,1.17,0,0,1-1.16,1.15H10.84a1.17,1.17,0,0,1-1.16-1.15V14a1.16,1.16,0,0,1,1.16-1.16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.72,67.7A8.84,8.84,0,0,1,24,70.3h0a8.85,8.85,0,0,1,0,12.53h0a8.84,8.84,0,0,1-12.52,0h0a8.85,8.85,0,0,1,0-12.53h0a8.82,8.82,0,0,1,6.26-2.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.72,70a6.58,6.58,0,1,1-6.58,6.57A6.58,6.58,0,0,1,17.72,70Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.31,10.75H60.12a3.29,3.29,0,0,1,2.3.95l.16.19a3.25,3.25,0,0,1,.8,2.12V57.59a3.3,3.3,0,0,1-1,2.3,3.26,3.26,0,0,1-2.3,1H45.31a3.28,3.28,0,0,1-3.26-3.26V14a3.26,3.26,0,0,1,3.26-3.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.31,12.85h14.8A1.17,1.17,0,0,1,61.27,14V57.59a1.17,1.17,0,0,1-1.16,1.15H45.31a1.17,1.17,0,0,1-1.16-1.15V14a1.16,1.16,0,0,1,1.16-1.16Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.71,67.7A8.84,8.84,0,0,1,59,70.3h0a8.85,8.85,0,0,1,0,12.53h0a8.84,8.84,0,0,1-12.52,0h0a8.85,8.85,0,0,1,0-12.53h0a8.82,8.82,0,0,1,6.26-2.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.71,70a6.58,6.58,0,1,1-6.58,6.57A6.58,6.58,0,0,1,52.71,70Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "12.4 19.72 24.08 19.72 24.08 21.8 12.4 21.8 12.4 19.72 12.4 19.72"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "12.4 28.98 24.08 28.98 24.08 31.05 12.4 31.05 12.4 28.98 12.4 28.98"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "12.4 38.23 24.08 38.23 24.08 40.3 12.4 40.3 12.4 38.23 12.4 38.23"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "46.87 19.72 58.55 19.72 58.55 21.8 46.87 21.8 46.87 19.72 46.87 19.72"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "46.87 28.98 58.55 28.98 58.55 31.05 46.87 31.05 46.87 28.98 46.87 28.98"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "46.87 38.23 58.55 38.23 58.55 40.3 46.87 40.3 46.87 38.23 46.87 38.23"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.69,12.8,97.29,10a3.17,3.17,0,0,1,2.43.53l.15.11a3.27,3.27,0,0,1,1.2,2c1.88,14.13,5.51,28.77,7.69,43a3.28,3.28,0,0,1-2.62,3.71L90.53,62.1a3.18,3.18,0,0,1-2.43-.53,3.25,3.25,0,0,1-1.35-2.09l-7.69-42.9a3.24,3.24,0,0,1,.53-2.44,3.28,3.28,0,0,1,2.1-1.34Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.06,14.87l15.6-2.8A1.18,1.18,0,0,1,99,13l7.69,42.9a1.17,1.17,0,0,1-.93,1.34L90.16,60a1.16,1.16,0,0,1-1.34-.93l-7.69-42.9a1.14,1.14,0,0,1,.93-1.34Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6,67.46a8.84,8.84,0,0,1,10.23,7.17v.06a8.84,8.84,0,0,1-7.17,10.23h-.06a8.86,8.86,0,0,1-10.23-7.17V77.7a8.84,8.84,0,0,1,7.17-10.23Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.94,69.72a6.57,6.57,0,1,1-5.31,7.63,6.58,6.58,0,0,1,5.31-7.63Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.1 21.12 96.66 19.35 97.04 21.39 86.49 23.16 86.1 21.12 86.1 21.12"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "87.84 30.23 98.39 28.46 98.78 30.49 88.23 32.27 87.84 30.23 87.84 30.23"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "89.58 39.34 100.13 37.56 100.52 39.6 89.97 41.38 89.58 39.34 89.58 39.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllIcon);
export default __webpack_public_path__ + "static/media/all-icon.5eac64278842a86f7eb72d82aa923773.svg";
export { ForwardRef as ReactComponent };